import { Injectable } from '@angular/core';
import { AppMetadataHandler } from '../../configs/app-metadata.handler'
import * as moment from 'moment';

@Injectable()
export class dateUtil {

  constructor(public appMetadataHandler: AppMetadataHandler) { }

  getDateString(rawDate: any): string {
    let dateString = "N/A"; // Default value for invalid dates
    if (rawDate != null) {
        let momentDate;
        if (Array.isArray(rawDate)) {
            const [year, month, day] = rawDate;
            momentDate = moment([year, month - 1, day]);
        } else 
            momentDate = moment(rawDate);
        if (momentDate.isValid()) {
            const momentFormat = this.appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR
                .replace("dd", "DD")
                .replace("yyyy", "YYYY");

            dateString = momentDate.format(momentFormat);
        }
    }
    return dateString;
}


  computeAge(birthdate) {
    const today = new Date();
    const birthDate = new Date(birthdate);
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();
    // If the birthday hasn't occurred yet this year, subtract one from the age
    if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate()))
      age--;
    return age;
  }

  calculateRelativeTime(comDate,effDate){ return "-";}
  calculateTimeUntilMaturity(maturityDate,eventDt){ return "-";}
}
